module.exports = "/images/side-site-design.svg?bd902abeaa3d2e908a86528231bb0a20";